<script>
	let nextTabId = 0

	// Register plain tab metadata so Vue 3 parent logic does not depend on child component instances.
	export default {
		props: {
			title: {
				type: String,
				default: 'Tab'
			},
            disabled: {
                type: Boolean,
                default: false
            }
		},
		data () {
			return {
				id: `tab-${nextTabId++}`,
				isActive: false
			}
		},
		inject: ['tabsApi'],
		created () {
			this.tabsApi.register(this.tabMetadata())
		},
		beforeUnmount () {
			this.tabsApi.unregister(this.id)
		},
		watch: {
			title () {
				this.updateTab()
			},
			disabled () {
				this.updateTab()
			}
		},
		methods: {
			tabMetadata () {
				return {
					id: this.id,
					title: this.title,
					disabled: this.disabled,
					setActive: isActive => {
						this.isActive = isActive
					}
				}
			},
			updateTab () {
				this.tabsApi.update(this.id, {
					title: this.title,
					disabled: this.disabled,
				})
			}
		}
	}
</script>

<template>
	<div class="tab__content" v-show="isActive">
		<slot></slot>
	</div>
</template>
